import { render } from "./BaseCalendar.vue?vue&type=template&id=970db82c"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"

import "./BaseCalendar.vue?vue&type=style&index=0&id=970db82c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__